const popular = [
	{
		title: "Money Heist: Korea - Joint Economic Area",
		video: "/assets/netflix/videos/Money Heist_ Korea - Joint Economic Area.mp4",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfEQMWocPVdpNjLRPmUy1I_f4po5GnpeXluByp6-8PqKu18yOvErs4FaBbuHCfEAERsXMtPtFuBU9c3QTnEQi-LfnZtodgbPCLaJmQ1yCpXmTOwBlWn4rPZYM4o-W9kkchO6.jpg?r=1aa",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABQwslcjXqMzUnrZkH24HLXBq0J_gOGR0hxStCT5Bj6F8G_Ya6s-LaFFyVaqPFhX8cSFXJZZ9QlpJVq0ri6geN8Pr9FSDT2z5UYXN1cUxYcjp73BMOENCeeNqauN9AVy_Ab7yZzsoRt0R6oNFVD0jCUfYflKnuzGLgAcinaRDP0nlunTSbp-k.webp?r=a1a",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABVrEk646clVqqfWp_o7e0HweiakxtIAONsg2F2PZcZmb1R__vbsfA5zUs_acE2heVUDnZjcsr2oD5smZwr6pj2OqWkXxLsCvBXv5.webp?r=3df",
		description:
			"Thieves overtake the mint of a unified Korea. With hostages trapped inside, the police must stop them — as well as the shadowy mastermind behind it all.",
		casts: ["Yoo Ji-tae", "Kim Yunjin", "Park Hae-soo"],
		genres: ["Korean", "Crime TV Shows", "TV Thrillers"],
		seasons: [
			{
				episodes: [
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABRvcZ6mxzlWHRwofSxgJx7hiqnzKvHhmP4bKrelPcuSs-iX_R8pjvTynwJmfx2v1OpqQz5rLmz_zPb5FuFzdQYusa9SikME-7IWqwiXIZHU_KQPSj8ve2aPQ.jpg?r=0e5",
						duration: "78m",
						description:
							"Recruited by the Professor for a job of unprecedented proportions, eight thieves storm the Unified Korea Mint. Police pull together a task force.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZxxnXDP8GpVDA8g3GqXOY6aW6fONE1rMBtet1Du-P-gsoXWAgMjmg4R6cfK9zx6SiGGREab2Fo6eS0v_3IGT_zrqLWXyYXUSp4ybYwhgSdQgcXl5_VOksNZ.jpg?r=a5c",
						duration: "74m",
						description:
							"Seon Woojin waits for a crack in the thieves' operation. An escape plan centered around the retrieval of a hidden smartwatch puts Yun Misun in danger.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABUp0CT34K5vYpgT-97MRZQAaV-33NZG9BXaIU1EaG8zgv7H3YHMMacE3LLXhASJwrK_K59IqLxy9CcVM3pv_WyJ48137ja82fBWyuez-i9rIGCldGtMVfNUN.jpg?r=cdb",
						duration: "68m",
						description:
							"The sound of a gunshot shakes up the Mint. Dissent among the thieves reaches new heights as some believe a line has been crossed.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbisCv7wxBOEi-zHZyL6QYOL2-U3Pwk-crHmOLg9D0c6J5nPPjcs0BOnwIDyYtjdpEvNm8cD2hZcWX1VZ2ew74JUdFsub9ERtnnN_fRBexiF33M3gewAyWTU.jpg?r=71e",
						duration: "70m",
						description:
							"Looking to turn a potential disaster into an opportunity, Woojin presses the Professor to allow medical personnel to enter the Mint.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABTxAoUZ3bBJ1o0PfQLnDNWricl8AX351Wcmupx_wEIIQjWlWlILL2KMSVvnuOG4godMuBgv5YwEDMOvLTZ9UxAPwvZ14oY_dW-bZHN4-6GpBiEkVev_BOHVT.jpg?r=55a",
						duration: "64m",
						description:
							"Cha Moohyuk hurries a plot of his own into action. A key revelation on Woojin's end threatens to unravel the Professor's strategy.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABTHP0ZhfOc6Secw5b-_cQelfHtQ788e8XwhS0Shc3PYnj3-H0GCUD66LaYhhFOMeQQdm1zJuTwKR2eCgRp5rhlUzEnIIzXj9qUtNUh-y2KpYREWKrKDS38D6.jpg?r=7e3",
						duration: "64m",
						description:
							"As those outside the Mint panic, Woojin proposes she go inside with a cameraman so the thieves can show the public that the hostages are unharmed.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABRyALsd7Q_fvoTrGhqgUIU1NP13a1sdzH7_O1I9RWSrq72xFYhCieBKeYk7JBez5fY50VCM5J6OWV3z9p4EfROkO09n_SMPYvXjI9YkqeasNjgmnISpk_gTL.jpg?r=55c",
						duration: "71m",
						description:
							"Woojin shifts her tactics after figuring out the real reason for the heist. Kim Sangman appeals to the thieves with a bold promise.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABVpb1xyMok0wZT47D_zRIdZLtML8Dge6LqpQEpDvZNv4we2LNcNyB0MXlSPX7qXwoocUMZep-sm1V35HxKSQ7C6to_dV_-_UpJ8wDoSbjGIMlAZ-ER97Hy_Z.jpg?r=130",
						duration: "68m",
						description:
							"The hostages set their escape plan into motion while Park Chulwoo calls for backup. Cho Youngmin’s attempt to be the first to leave the mint backfires.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABVXT4VGoIozVon8BSKBC0Vpk5NCCi6x3r3rUvBkV0_JneGLUK5IhsUDnJ2uny-HVezH69K-ni_98BtbjeXwi-B-PqdW2R7TnE750VIKKGnw5HYFM-UFAttd0.jpg?r=1d9",
						duration: "68m",
						description:
							"The police interrogate a thief. Sangman steps in to take control of the hostage negotiation. A rescue mission takes place to bring a child to safety.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABcw_tKm1fSzzJXynTFOx3RarE8WlRFiH3xnxBTZULuBnddJYz2ZQ14CjaFdekFQfnQzKJkZZ3LJkST9oI54bwCPem1OThA1UW-BFN4X43ynjSC9elqUnbZFq.jpg?r=2d7",
						duration: "70m",
						description:
							"The thieves offer the hostages a choice between money and freedom. After finding out about his son's love affair, Moscow reveals his past..",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABQx9GsGy5-WP9tfYV00zOlvLJq8aw8rjOMRs217Pz5Md8Bo1KavswZ3k0gfbn7EFFYH7jUCSxhDpeEetVFVN6NJTe3vBUvwL5JtJ2vGd_C838trTrTHLyp9y.jpg?r=508",
						duration: "69m",
						description:
							"A medical emergency puts the thieves on edge, while the deadline to carry out their plan is cut short. Woojin lures the Professor to a nearby hospital.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABVTMGW8xuwj0JrJJmf1cX9SiK7oQDK4xorm2VCNOllX9IfCYonwcBgETUVN8ERhRNzrwyaB4trM_t9DPomBl4v341RwQ-bZ7bOboQqevNHXfyvDDzpwn3gKI.jpg?r=447",
						duration: "77m",
						description:
							"The police close in on the thieves as they prepare to transport the money out of the Mint. Fierce protests force Sangman to put his foot down.",
					},
				],
			},
		],
	},
	{
		title: "The Good Doctor",
		video: "/assets/netflix/videos/The Good Doctor.mp4",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABbAtol4N8au3_vTzBVW9pYcJSGBApH3A5LKKwu3M7fuP8mMT1dEfuA2BdLriBp_ZFf48x-mmHww0VflpZOoqBjiUQJQjkYM4Yt_UCV1lRZNCByTBVrkdorSN5bY-qDx4nwjEmrzLyQMgBN4z_cmuQEwcWLezzMW3cos8xKbh12ueRnlIqYo80LAsFXRTHDkp6sP8_Jcpx3T_-6ulFocfja0vBNPq57PMSd5j0umtXhFj84jihKdbHtiM6IBaWlkVDrK_wUjelIm3F4Mmmq_Mr0Y.webp?r=65f",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABWIhhxyr4La38UdC5i_nh-cHWxb2awKmYHP073mzL5_ZsQgVM5ncHl7dLkq9w-9LG_Kj__3cnBv3MrGQDMm5IoDWXZ5iFOCSCkMqzWctCoQ.webp?r=8ba",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABcqj_R2bz1M0Jr6mxfHnsmLvC8onSjWAMWz-3MmBW-PF8gu2JwhmS8GaTJ4l5dkuXDGO2xq-s-xLSxNjT18kJ1ZrM2TFX8Hxxdud.webp?r=6f8",
		description:
			"A talented surgeon with autism and savant syndrome joins a prestigious hospital, where he faces skepticism from both the patients and staff.",
		casts: ["Freddie Highmore", "Hill Harper", "Richard Schiff"],
		genres: ["Medical TV Shows", "TV Dramas", "US TV Shows"],
		seasons: [
			{
				episodes: [
					{
						name: "Burnt Food",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABTzekyag3SL__n2G8YzbshT354WBN9lL3M1-WKmsHJJbw3Zie4eQYceHvuNiHaIB5GSU5PYYKnnPaFZDt_7JkamZLWfToqONOQ7TEGtCrBf2iXVhrIJkUYO0.webp?r=bbd",
						duration: "43m",
						description:
							"A young surgeon with autism relocates to California to complete his training and relies on his top-notch skills to disprove his colleagues' skepticism.",
					},
					{
						name: "Mount Rushmore",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZkHnZXuP739MfWj416hVKm5usCiZkWwMJsj28pXmGnViR06JxpbcMhLYOAPce4bwM4kDfK3Dk72ntv_IlhetMpbB7Q1By2gYHocorV5dJiRT-uxHy5dRXmr.webp?r=311",
						duration: "43m",
						description:
							"When prejudices about his autism force Shaun to sit on the sidelines at St. Bonaventure, his colleagues don't hesitate to claim credit for his ideas.",
					},
					{
						name: "Oliver",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABTru8ImeoBVTW1iQSmA8DogNxsKYJKX833AByMtyN4AwCbJtVAt0TN-XfvzAo77-xCxzgMdjEaHjYICWgc8IZQ_XioOYKtk8X7ubewIoS_sJAAEYOQ8zvSh5.webp?r=2d9",
						duration: "42m",
						description:
							"As Shaun and Claire improvise to preserve a liver for a transplant, Marcus is pressured to partner with Neil on a wealthy patient's routine surgery.",
					},
					{
						name: "Pipes",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABUAJt4J5aI_WZQ---wUejN-gpPwU1ZDGziQB9LrNMFZG-t4IUUWPpWZdT3kAlj-MbzM7Jas_s6nqe7HyRbJjeiy4F20jObLfmmb9Lz9G_gRd46POuJntPk1A.webp?r=787",
						duration: "43m",
						description:
							"Neil takes a risk to save a mother and her unborn child, placing the hospital in legal jeopardy. Shaun and Claire treat an adult film star.",
					},
					{
						name: "Point Three Percent",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbBXHyONeNOba3QyQOJRgQfjaKTDpui1BJcgW-Ks2Gwgs32UdSpdrTwdk0Yyq1eECzo4xhNEVJsEAiApddVK3BKt3HXyLqaXtGm3iCQxW0_mXW4RmCY_SQjr.webp?r=4eb",
						duration: "43m",
						description:
							"Shaun suspects a boy has been misdiagnosed with cancer. A patient's allergic reaction exposes a longstanding rift with his son.",
					},
					{
						name: "Not Fake",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABXYOEwn_-sghVhdviaI9p8OOD0RM6ny65Fz1x4nPGyRz6BYY3odiLg79alev_Sc4Xuu0f4MfTF0LQspnb-DYj8f8VUwFwwGTAKvvwtFDI-DJXLAm6k7vP3mR.webp?r=248",
						duration: "43m",
						description:
							"Shaun and Claire devise a procedure capable of saving a young groom's leg and life, but the patient's loved ones must learn to work together.",
					},
					{
						name: "22 Steps",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABUUQh8mTuSQrsrtmz5-72p7HS5M81Wtp4RsXRruur3-7EoRRMT6S7y3nxxv5AteHllHbRcj0y3aoL6bngzgeVRKvMgLeRC8g9hDzUc6azEjDWZFs0CuwtNz2.webp?r=794",
						duration: "42m",
						description:
							"Shaun confronts prejudice from an unlikely source when he takes on the case of a patient with autism. Jared confronts his limitations as a surgeon.",
					},
					{
						name: "Apple",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABf9xi3Lw4-QB8PVtr_7N-yXNs4PxRk6Vx-Z6TIWGxufdHHZxsO_S5VzLhAJz7l7BbZQGOz2Nb6CQ4TEeMj_C3DMS3EAIUoXTtRGMmQlv3RM1v7ecNTiWIuvf.webp?r=f1c",
						duration: "42m",
						description:
							"Shaun's communication puts lives at risk during a robbery. Meanwhile, after Shaun's traumatic day, Aaron worries he isn't doing enough to help.",
					},
					{
						name: "Intangibles",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbgzZ06b0-yYVGCgZnXF49zAYdO-GvBhSFUGmG1k2OZViOfQIwy6GRzDdyxzmMYJ2gPtTDbxg7Cx7KAaeA1RqY_2HHtCgLVeoZLLUhjAqux6S2qshxmMkjNK.webp?r=65a",
						duration: "42m",
						description:
							"Neil feels the pressure to save the life of a gravely ill boy. A missing tissue sample leaves a mother facing potentially unnecessary surgery.",
					},
					{
						name: "Sacrifice",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABcl9UdcMhNZaVEmKqPkjIILwafLxWkbSCiFFsSpswqKefPay3smXB0qfz5eX9g452jzmv8PsAJUpgDr-mfQX1uZXrB-9mIHeb4Rq_GYPg9lLb1uoMzh4yuAF.webp?r=cd8",
						duration: "43m",
						description:
							"An initially charming new doctor puts the surgical team in an uncomfortable position. Shaun and Neil treat a professional gamer.",
					},
					{
						name: "Islands: Part 1",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbwiDniL62IgFGvTuQKaoTGXYPYpt36auwAXI5bFe-oyJ7BarNsEPcns836h6LufKJUw3THJIF-vzJUxpWANtmDWdfB8eVxeLHAXBVsg-wKBF0Uq08dxacfV.webp?r=d81",
						duration: "43m",
						description:
							"Marcus enlists Neil on a sensitive kidney transplant between a pair of twins. Meanwhile, Shaun begins to feel overwhelmed by the pressures of work.",
					},
					{
						name: "Islands: Part 2",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABRPOto4_3Xlxlg5uYlQMVrquWBt2vdMcCxvskyySbBgOnEwSWphJZSjGuMHPfZAdpEWul2CCIPijDeJNPR6M4WokZpp3ohXN7YJXrnlE60GUemei-uuW4aia.webp?r=4a2",
						duration: "43m",
						description:
							"The twins suffer complications from their surgery, forcing the team to make a life-changing decision. Shaun makes a surprising announcement.",
					},
					{
						name: "Seven Reasons",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABSedY5a3DS7jDZV4kxmC0Evus8KXkV4EGfQ2dDmbafoangE-26yAlT8Xxx1dQY1cWerh5zU3QSi9mDAZWxX380EJnkJ_wophL9kaE58PH4FSO7cdPDpCyk8R.webp?r=b17",
						duration: "43m",
						description:
							"Shaun suspects his patient is lying about the reason for her injury. Meanwhile, Neil's personal life could be impacting his patients' lives.",
					},
					{
						name: "She",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABW6QY5rF0-8q-vsuefAjAuj_yKlkubH9niD75VcEDtTXfBz_0MiTgWyzcGo9X5i766MLYPYTQ7M89MsmQ_fBHE9UxzBq6wPvrYKM-hGICw_ZWsjFncOBRwLE.webp?r=02e",
						duration: "43m",
						description:
							"As Shaun and Jared debate how to treat a child's cancer, Claire and a competitive new resident must work together to save a single dad from a superbug.",
					},
					{
						name: "Heartfelt",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbLXnuysjWSDELlgAzPN_nrOe6L0T9ebKtfO8GY9nyKQbl04PwOCOvEg9qfJz7Zi5RtcnUCw5Boxa6TabM06snNpH6Ebm6GTZeBuJ3tfpt4xzbXxk-FA2s6w.webp?r=7e3",
						duration: "43m",
						description:
							"An operation to correct a teen’s heart defect puts Shaun and Morgan at odds. A new resident doubts a prisoner’s motives for being an organ donor.",
					},
					{
						name: "Pain",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABeTuX2mAvLBng0XoVPbC_Yhci8241TixLz7v0hTrGsATMGoPbEUIuiOqOA4sKITiDF67BmGfQ5i0c7Jp04Qi0SdiVP0463D5fwSowWEDlpOO0IRh8Ph4vMdG.webp?r=5a0",
						duration: "42m",
						description:
							"A paralyzed man’s unexpected feeling in his legs leads Neil to suspect he can walk again. Marcus must undo a cosmetic surgery gone awry.",
					},
					{
						name: "Smile",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABf7Kzq8nkhWXlUy8NsrKzsEc8sBb0nFYrVdBd3fVNk9LKCAGsfSER5A9oDNGRIkqGHoiSUFG_C1-rneuK2V41FO3I-SQL5oWlnsADzD8sYpS0x5XE_tK1lUz.webp?r=1bb",
						duration: "43m",
						description:
							"Claire and Morgan disagree over how to handle a patient using a stolen insurance card. Shaun bonds with a teenage patient preparing for surgery.",
					},
					{
						name: "More",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABcvJ3nKT-A4VQ7G2NWeA2uvZkq_FpCZBJ97Ciu1MJh2CYZ35Zof_li3ih55IorGTMXtpk90IICwhY0AStSvismnPTRHHI0V4b9DCbn02BhQ4bodlY9X_pxoA.webp?r=2ae",
						duration: "43m",
						description:
							"Shaun receives some troubling news about Aaron's health. The team tries to uncover the truth about a college student's injuries.",
					},
				],
			},
			{
				episodes: [
					{
						name: "Burnt Food",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABTzekyag3SL__n2G8YzbshT354WBN9lL3M1-WKmsHJJbw3Zie4eQYceHvuNiHaIB5GSU5PYYKnnPaFZDt_7JkamZLWfToqONOQ7TEGtCrBf2iXVhrIJkUYO0.webp?r=bbd",
						duration: "43m",
						description:
							"A young surgeon with autism relocates to California to complete his training and relies on his top-notch skills to disprove his colleagues' skepticism.",
					},
					{
						name: "Mount Rushmore",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZkHnZXuP739MfWj416hVKm5usCiZkWwMJsj28pXmGnViR06JxpbcMhLYOAPce4bwM4kDfK3Dk72ntv_IlhetMpbB7Q1By2gYHocorV5dJiRT-uxHy5dRXmr.webp?r=311",
						duration: "43m",
						description:
							"When prejudices about his autism force Shaun to sit on the sidelines at St. Bonaventure, his colleagues don't hesitate to claim credit for his ideas.",
					},
					{
						name: "Oliver",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABTru8ImeoBVTW1iQSmA8DogNxsKYJKX833AByMtyN4AwCbJtVAt0TN-XfvzAo77-xCxzgMdjEaHjYICWgc8IZQ_XioOYKtk8X7ubewIoS_sJAAEYOQ8zvSh5.webp?r=2d9",
						duration: "42m",
						description:
							"As Shaun and Claire improvise to preserve a liver for a transplant, Marcus is pressured to partner with Neil on a wealthy patient's routine surgery.",
					},
					{
						name: "Pipes",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABUAJt4J5aI_WZQ---wUejN-gpPwU1ZDGziQB9LrNMFZG-t4IUUWPpWZdT3kAlj-MbzM7Jas_s6nqe7HyRbJjeiy4F20jObLfmmb9Lz9G_gRd46POuJntPk1A.webp?r=787",
						duration: "43m",
						description:
							"Neil takes a risk to save a mother and her unborn child, placing the hospital in legal jeopardy. Shaun and Claire treat an adult film star.",
					},
					{
						name: "Point Three Percent",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbBXHyONeNOba3QyQOJRgQfjaKTDpui1BJcgW-Ks2Gwgs32UdSpdrTwdk0Yyq1eECzo4xhNEVJsEAiApddVK3BKt3HXyLqaXtGm3iCQxW0_mXW4RmCY_SQjr.webp?r=4eb",
						duration: "43m",
						description:
							"Shaun suspects a boy has been misdiagnosed with cancer. A patient's allergic reaction exposes a longstanding rift with his son.",
					},
					{
						name: "Not Fake",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABXYOEwn_-sghVhdviaI9p8OOD0RM6ny65Fz1x4nPGyRz6BYY3odiLg79alev_Sc4Xuu0f4MfTF0LQspnb-DYj8f8VUwFwwGTAKvvwtFDI-DJXLAm6k7vP3mR.webp?r=248",
						duration: "43m",
						description:
							"Shaun and Claire devise a procedure capable of saving a young groom's leg and life, but the patient's loved ones must learn to work together.",
					},
					{
						name: "22 Steps",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABUUQh8mTuSQrsrtmz5-72p7HS5M81Wtp4RsXRruur3-7EoRRMT6S7y3nxxv5AteHllHbRcj0y3aoL6bngzgeVRKvMgLeRC8g9hDzUc6azEjDWZFs0CuwtNz2.webp?r=794",
						duration: "42m",
						description:
							"Shaun confronts prejudice from an unlikely source when he takes on the case of a patient with autism. Jared confronts his limitations as a surgeon.",
					},
					{
						name: "Apple",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABf9xi3Lw4-QB8PVtr_7N-yXNs4PxRk6Vx-Z6TIWGxufdHHZxsO_S5VzLhAJz7l7BbZQGOz2Nb6CQ4TEeMj_C3DMS3EAIUoXTtRGMmQlv3RM1v7ecNTiWIuvf.webp?r=f1c",
						duration: "42m",
						description:
							"Shaun's communication puts lives at risk during a robbery. Meanwhile, after Shaun's traumatic day, Aaron worries he isn't doing enough to help.",
					},
					{
						name: "Intangibles",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbgzZ06b0-yYVGCgZnXF49zAYdO-GvBhSFUGmG1k2OZViOfQIwy6GRzDdyxzmMYJ2gPtTDbxg7Cx7KAaeA1RqY_2HHtCgLVeoZLLUhjAqux6S2qshxmMkjNK.webp?r=65a",
						duration: "42m",
						description:
							"Neil feels the pressure to save the life of a gravely ill boy. A missing tissue sample leaves a mother facing potentially unnecessary surgery.",
					},
					{
						name: "Sacrifice",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABcl9UdcMhNZaVEmKqPkjIILwafLxWkbSCiFFsSpswqKefPay3smXB0qfz5eX9g452jzmv8PsAJUpgDr-mfQX1uZXrB-9mIHeb4Rq_GYPg9lLb1uoMzh4yuAF.webp?r=cd8",
						duration: "43m",
						description:
							"An initially charming new doctor puts the surgical team in an uncomfortable position. Shaun and Neil treat a professional gamer.",
					},
					{
						name: "Islands: Part 1",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbwiDniL62IgFGvTuQKaoTGXYPYpt36auwAXI5bFe-oyJ7BarNsEPcns836h6LufKJUw3THJIF-vzJUxpWANtmDWdfB8eVxeLHAXBVsg-wKBF0Uq08dxacfV.webp?r=d81",
						duration: "43m",
						description:
							"Marcus enlists Neil on a sensitive kidney transplant between a pair of twins. Meanwhile, Shaun begins to feel overwhelmed by the pressures of work.",
					},
					{
						name: "Islands: Part 2",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABRPOto4_3Xlxlg5uYlQMVrquWBt2vdMcCxvskyySbBgOnEwSWphJZSjGuMHPfZAdpEWul2CCIPijDeJNPR6M4WokZpp3ohXN7YJXrnlE60GUemei-uuW4aia.webp?r=4a2",
						duration: "43m",
						description:
							"The twins suffer complications from their surgery, forcing the team to make a life-changing decision. Shaun makes a surprising announcement.",
					},
					{
						name: "Seven Reasons",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABSedY5a3DS7jDZV4kxmC0Evus8KXkV4EGfQ2dDmbafoangE-26yAlT8Xxx1dQY1cWerh5zU3QSi9mDAZWxX380EJnkJ_wophL9kaE58PH4FSO7cdPDpCyk8R.webp?r=b17",
						duration: "43m",
						description:
							"Shaun suspects his patient is lying about the reason for her injury. Meanwhile, Neil's personal life could be impacting his patients' lives.",
					},
					{
						name: "She",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABW6QY5rF0-8q-vsuefAjAuj_yKlkubH9niD75VcEDtTXfBz_0MiTgWyzcGo9X5i766MLYPYTQ7M89MsmQ_fBHE9UxzBq6wPvrYKM-hGICw_ZWsjFncOBRwLE.webp?r=02e",
						duration: "43m",
						description:
							"As Shaun and Jared debate how to treat a child's cancer, Claire and a competitive new resident must work together to save a single dad from a superbug.",
					},
					{
						name: "Heartfelt",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbLXnuysjWSDELlgAzPN_nrOe6L0T9ebKtfO8GY9nyKQbl04PwOCOvEg9qfJz7Zi5RtcnUCw5Boxa6TabM06snNpH6Ebm6GTZeBuJ3tfpt4xzbXxk-FA2s6w.webp?r=7e3",
						duration: "43m",
						description:
							"An operation to correct a teen’s heart defect puts Shaun and Morgan at odds. A new resident doubts a prisoner’s motives for being an organ donor.",
					},
					{
						name: "Pain",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABeTuX2mAvLBng0XoVPbC_Yhci8241TixLz7v0hTrGsATMGoPbEUIuiOqOA4sKITiDF67BmGfQ5i0c7Jp04Qi0SdiVP0463D5fwSowWEDlpOO0IRh8Ph4vMdG.webp?r=5a0",
						duration: "42m",
						description:
							"A paralyzed man’s unexpected feeling in his legs leads Neil to suspect he can walk again. Marcus must undo a cosmetic surgery gone awry.",
					},
					{
						name: "Smile",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABf7Kzq8nkhWXlUy8NsrKzsEc8sBb0nFYrVdBd3fVNk9LKCAGsfSER5A9oDNGRIkqGHoiSUFG_C1-rneuK2V41FO3I-SQL5oWlnsADzD8sYpS0x5XE_tK1lUz.webp?r=1bb",
						duration: "43m",
						description:
							"Claire and Morgan disagree over how to handle a patient using a stolen insurance card. Shaun bonds with a teenage patient preparing for surgery.",
					},
					{
						name: "More",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABcvJ3nKT-A4VQ7G2NWeA2uvZkq_FpCZBJ97Ciu1MJh2CYZ35Zof_li3ih55IorGTMXtpk90IICwhY0AStSvismnPTRHHI0V4b9DCbn02BhQ4bodlY9X_pxoA.webp?r=2ae",
						duration: "43m",
						description:
							"Shaun receives some troubling news about Aaron's health. The team tries to uncover the truth about a college student's injuries.",
					},
				],
			},
		],
	},
	{
		title: "Peaky Blinders",
		video: "/assets/netflix/videos/Peaky Blinders.mp4",
		creators: "Steven Knight",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABRbyOaaLIpetkVsg4ibIHQM7fT5it52LdIL2cJh3g64usYAoKnTOr-yStg_3-jUnY0EXTkwyIikcmBPEkjXOo1jbC0DAHSQAQeJFKPvOm2HgaFXlbtq221naXnJJyokA759Z0A.jpg?r=a07",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABT_uDyKx4UN-FkQeyfC7pgm0ER5wIFztIR2qDFKCYtsEJfYkr9sA7eu7iZyJFy2jOnsctY44NwFMCYzTYBGBoFXejiDk9nKPDO3n.webp?r=961",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABXATnou9lAifkkwnTkgHnTL843mPJnl8DvLJUNokZkepr5j3IOD75YzbJ956IRYAAVu_Aio8dxLB-iydkmmjoEM0XW9zeLyuEvlKcMi5r2FGeLrdlU1UyX3iLV-EBSkR9NG3iuHMvam8NOxOHc2s8EtmKwbwm8x8zn4mJSwSii0f9G1aeAvM.webp?r=f38",
		description:
			"A notorious gang in 1919 Birmingham, England, is led by the fierce Tommy Shelby, a crime boss set on moving up in the world no matter the cost.",
		casts: ["Cillian Murphy", "Sam Neill", "Helen McCrory"],
		genres: ["TV Dramas", "British", "Period Pieses"],
		rating: [
			"gore",
			"language",
			"nudity",
			"sex",
			"substances",
			"suicide",
			"tobacco use",
			"violence",
		],
		seasons: [
			{
				episodes: [
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZGF2Q8Vlbz7Y_WCYd4jHW0NKm_tcSD7ID5cdfezTToSyuMYnv2193RsfINKA9yHLuyDpSjkOZxLChhFIgECPMgrY65Bw5bsbR26VqXcHyCzr2NSaZtBEysV.webp?r=c76",
						duration: "57m",
						description:
							"Ambitious gang leader Thomas Shelby recognizes an opportunity to move up in the world thanks to a missing crate of guns.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbmQ9vRwoUiJSm_5wWnXUJe5bWfj9Aal-Meu3ocndQq70mm-MpdH4YDsGUFVWa3SFWzekFVti9hyHag-H3E0PBCchMz3ptacbBlaNZYuPdpBOXfcXAnAr3-n.webp?r=c06",
						duration: "57m",
						description:
							"Thomas provokes a local kingpin by fixing a horse race and starts a war with a gypsy family; Inspector Campbell carries out a vicious raid.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABSDBlWrDxT5Vzg-oECmGP0pJNftSC_ZFrPFKwY9mcxHicY27p0tdUreXq0vOlTKooVt4L2iCjVdF1LxgzEr1LDm5eCOnKkSs1FKw83K0qfo6C8cvghusL_63.webp?r=b69",
						duration: "55m",
						description:
							"As his war with the Lee family escalates, Thomas harbors suspicions about his brother's fiancée; Campbell pressures the gang to deliver the guns.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbjjeDyfNSIzeow80dL6qKI3_0ujAO7oK-BOs0lR4gdC_QC_PQBH0m4WIprNnshwOkiFTT55gfFdr93O6aPXiXgrGX-ZkaeQVwnWQbjnmh2y-OcchQEmRO8E.webp?r=753",
						duration: "58m",
						description:
							"As his war with the Lee family escalates, Thomas harbors suspicions about his brother's fiancée; Campbell pressures the gang to deliver the guns.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABXA4tDpVRtZItVHKH_8LksvPX5CQPvLgwokvE4oELLjDkdsmdZuBd6I2OY6R1RSJNnjyeHjAhff0uQ2XAvYjbwYG57t57LdIAtUNr9I9Ja9ZkN6eqFK525fN.webp?r=a07",
						duration: "56m",
						description:
							"Thomas deals with an IRA chief bent on avenging his cousin's death; Grace must decide whether her loyalties lie with Campbell or Thomas.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABWtM-d30zOOd2W8MFheYswFey6wXSmCknE7E6yAiNWTwxKPmhhjc--oAEJzzVYOiSFFclwDNY0Smu5yw_Gvq8Gv28S3BR9KCWAqd_kZ2JG0egHHBIP_XePj3.webp?r=e86",
						duration: "54m",
						description:
							"Thomas prepares to oust Billy Kimber from power, but family secrets that come to light and the obsessed Campbell may prove his undoing.",
					},
				],
			},
			{
				episodes: [
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABXbOPYXMVjHhkpx5ZUjv026bNTatezSdL6fZ5V9Isdqo51Ug1pt92ml3hPrz_OHdyQcrjkFr8ch0fRdVcBd_H4J1u7Ll9Z5SYEwkqrGUU0P0VeQYpmqef8b3.webp?r=f51",
						duration: "59m",
						description:
							"When Birmingham crime boss Tommy Shelby's beloved Garrison pub is bombed, he finds himself blackmailed into murdering an Irish dissident.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABQm1AGY5HMu_7PHQZ-k3spCV3ky7KvLwt06DRvMVYdaKnbnmvyYoNethvDz66hm9KbfDB20c1X1lj3AFmdruT7igbgcAn1tG3Pn4Y23aZndx1DFztVr43OjV.webp?r=5a6",
						duration: "57m",
						description:
							"After murdering an Irish dissident, Tommy has no choice but to be a pawn in Inspector Campbell's treacherous political game.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZKvDTT8R9VRNZCT6ak786Khtbz29KgZW-xB8Q1JZVj_1OCJrF22yEiwwByMy7P8Hxl0BN5GyYAIe1Rhof49SyOWtRPq7gTzt7Ita-xMZNm9_m29G47sinD5.webp?r=a44",
						duration: "58m",
						description:
							"After joining London crime boss Alfie Solomons in a business venture, Tommy worries that Alfie's newly revealed volatility could pose a problem.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABckq7RYfjIrw3sWQoUjaJuGC3Jp_viDZC8obzX4563MHRSPJF-KUzIPm88t-Xz16oDp7HMCRfnXhy4G6U0TzPUC63piCyjB_Ppi3JkoP0c2RCG9SdKrv6fRJ.webp?r=fba",
						duration: "57m",
						description:
							"The Peaky Blinders take over London's Eden Club; Sabini convinces his old adversary Alfie Solomons to join forces and eradicate the gang.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABdzkzfu3plULSDiuyL2KASohL8uuie4IiEDxJtN8PtVEo10BHz4SUb0N9vEKyVMLVxWzmdTGaph6BbmlvXBpeDWi6sTbTD_M-ngIthCUgQgdSDQ9kTdqgfjB.webp?r=63b",
						duration: "58m",
						description:
							"The Peaky Blinders are under attack. Tommy's power base in London is obliterated, and both Arthur and Michael are arrested and imprisoned.",
					},
					{
						name: "Point Three Percent",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbr5T4sgzlOpqWQRaHyKZBgfuJdnp0syC5EAuopN3aQ3greGmdo07Rlo-ZF4nOGPR5ENwd4_9kvObBplfkK_XN78sBe8dHqEL28e4OKx1rXS1dURfnaY5Ion.webp?r=856",
						duration: "58m",
						description:
							"Tommy plans to execute the mission given to him by Campbell: the assassination of a high-ranking member of the military establishment.",
					},
				],
			},
			{
				episodes: [
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABf0s9VjhkaHYc44v1bpQbyXNhsaFR_TRAg4H_m-Gsm72Mv1qNzTRohXyBbbp6e4YrELXrA5PWfL7wqeZUedpdqeqL8tsrDtg59UMqBWfwPPvQPK-hiR0F-Rx.webp?r=9cd",
						duration: "55m",
						description:
							"On Tommy's wedding day, a new business partner arranges a secret transaction. Arthur has found a godly woman, and Polly meets an attractive man.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABSYeDS-5wX5OmuFPQWiCv_Ql8y0S9JXzJmWlDlNyKTHGTuUfWDmJmcLselJkObZLqodIuPio351Foa66euonNatVIudxGn5Mjnui_x-oGf2HkfZsC8ciJXoG.webp?r=58a",
						duration: "57m",
						description:
							"A careless threat sparks a war. Tommy gets a rare form of payment, but his bosses flex their power to keep him in line. Polly commissions a portrait.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABf0eG_5iYO4buy2aBbDy78sQmqc7ILUJ17keoDG83RtrDpoclejH8rgaHjgM8GNNEDBZGIgk5nwLPGowxpx-An4W8oGS43je0MvuguznNTr2j71fyfA6n7Pf.webp?r=18c",
						duration: "58m",
						description:
							"Tommy travels to Wales seeking absolution, and uncovers a traitor in the Economic League. Michael develops a taste for guns. Arthur gets good news.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbKHsKvtWhuRc0YBhPCFx911OJKwdt9Rg1-ObrXw4EzBQMcOK8K1c9bM-o6OYvzluB2TbKT2W5tJpu_CbF6S4bzZavWT9tazjh_Mk0NBmreQ-d1fTxA_8Aix.webp?r=73f",
						duration: "54m",
						description:
							"Polly goes to confession, igniting a chain of events that reveals a trap being laid at the Shelbys' expense. Tommy plans an exit from dirty business.",
					},
					{
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABQUEqSSvnJWZiwxWxr3N6m6E50UYNwzEHMgEnkr4fwQpsOveVwSj6JLlyEdrEIL4GUMAFk4lia5QmAZnMh3VQ8eYpaXk671rEdfLtJn13rDT-nDfo19g6q_v.webp?r=9c7",
						duration: "57m",
						description:
							"Realizing he's being outmaneuvered by the Russians, Tommy seeks help from a former business partner. Polly's new friendship becomes something more.",
					},
					{
						name: "Point Three Percent",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABfwTTmPX8zWe-TGNngUrFsVozQXUKQVgpnuQxjtFEVyM9fibff8LiA1beqeGN3BzuWnYNRZ0pRYEl73ZZ5dABPDSbTTa--mWIZ-noU69PSSrgnbvhrFCS4bt.webp?r=249",
						duration: "57m",
						description:
							"As Tommy prepares to commit the most audacious crime of his career, an unexpected blow forces him to face his worst fears in a race against time.",
					},
				],
			},
		],
	},
	{
		title: "Society of the Snow",
		video: "/assets/netflix/videos/Society of the Snow.mp4",
		creators: "J.A. Bayona",
		duration: "2h 25m",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABSbCNM1NjMtvBygoTJXZjVK_0Ro72M-SQOfMScXS6rcWOGmH3AbtZKPSv3qbxbmfmakJgVakjnzST7ch65VD2jReNIxI-f78Hm5lMQN0DKS3aZzYXOnvtKvDIzIkVDFyny_fLmw17NAhIjzGR1jRWTuUxOF9GBdDRVliDD-4I2WxSgOKsHJBPAEnj48K5eORFlzOd-WYFXZHMWijnFlGRAUElBJJVvwXS5ajlvOnIRDYMNVOIvcTO9o7AG6GmSBx5QQPirWT9EQxuZPdM1VkZ2RM3aC4E89o9CX63BH7bkh-3VuopzMSu5hd6J7YBs2Too1gBL6rjs_s9XdDQo9BEY-EQLRKmyAb6WLf00n9mKRs7kts41Q.jpg?r=864",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABbpOe1spWf_RnVILVQJnzcs8EoRWvp6xcRbWumPZaRqmF7lMTt9YUPW2aLr5rMHtVnriG91uIK1PdksACZQ8AgAEy8ujrCfY7mtz.webp?r=393",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABXJcFjTDXyi0Uzk_VUC535WL3og_Ih7oDeCHlgswFxJfmK34vPNHyCFR1ybKImdKQxDqnlQ4tRyOFBSAcF5m7b3QSglromnA61G1_SFd6a6py5YD0-gRs1ZRDTDjbl8-rJr1pq_w6DVo3hAFniW6ilb77K2qHRC-jWbneGeMfA1wUTwtv582.webp?r=2ad",
		description:
			"Following a plane crash in the remote heart of the Andes, survivors join forces and become each other's best hope as they navigate their way back home.",
		casts: ["Enzo Vogrincic", "Agustin Pardella", "Matias Recalt"],
		genres: ["Spanish", "Dramas", "Movies Based on Books"],
		rating: ["disturbing images", "nudity", "tobacco use"],
	},
	{
		title: "Top Gun Maverick",
		video: "/assets/netflix/videos/Top Gun_ Maverick.mp4",
		creators: "J.A. Bayona",
		duration: "2h 11m",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABfDeG0Olf5eaACwJyUrIy2EXhi5VoWkQWK9j6XLRPPrGb83Uichh-BmaAhL9y-SlbzjkWirzmSYVkhYiIifriUws04CPE7UY5RAplW8f3awVsrQXm6O4yNa2uciMBptDovqOWPvPIVe_ulU7qQnox-n_jjtAzd-qohDHaAf4Eh9Au0TLoCusUQY6accIM88fp6WGZz0Nd-i1PjiHswI52kMFJgFtD-5daLgwCYV27cMd7z1AqG2vth1aq5Mu0KSKUTd75C3TbhBpgLPbZNrzhoHPOxkq.webp?r=67e",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABXjjbOVR8qRhNmDm2TPbeY2_ub8tiVPB1-CrhsFB6e_kWGQBBl8m2SqI-qtRVyXDZuuXwPN3kjymyXN9GoUQzypSHbkDhRvhTgCn.webp?r=310",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABct_rZRPERMGwNoJNpgVKu7vYi3ejjm_Q59OgMl4q_3syd98TzfbQBgdA5ixdbiIXuvFmEooPlUQn6riIBFZS3qI7zsvKzT9gvvUAha8wuw.webp?r=2ad",
		description:
			"After more than 30 years as one of the Navy's top aviators, Maverick trains a group of Top Gun graduates for a specialized — and dangerous — mission.",
		casts: ["Enzo Vogrincic", "Agustin Pardella", "Matias Recalt"],
		genres: ["Spanish", "Dramas", "Movies Based on Books"],
		rating: ["disturbing images", "nudity", "tobacco use"],
	},
	{
		title: "hi PAPA",
		creators: "J.A. Bayona",
		video: "/assets/netflix/videos/HI PAPA.mp4",
		duration: "2h 36m",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABY0pR3-vZDBxDnQNbSc_bJC5s_OdK7FFlhKWpRb95xIRENb7-S6cwUQej6LMu4usoMJ-s1xrk88nAd0OIsN2aGkirLU0Fw4OgXaDQTb75wf8UrExI9u-M53Th0tf2dc2dKDfwr0bF4vpd3dIK0ep4uUOysI1qiIvpzXIIJmQYMQPbawFH9SDibDGk2OXIaDYjY6jEBIgQF1Go7uO7gKw_dp-9B733kMkb1kXUmp20Dr1QM5C_popz_A3WmAmocljgeQsEi-tMOM2Bw-bPOm4zouy82gFe-eAAe827SPfnUgXblzhZ2faFuuop9FlUWhAg_SwyXzAwmIWUdz0PpxSfHOZ.webp?r=313",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABeB2KLfvgEmIrtCjuo3u9VmkNJQw0fdvDqoNda9S1q8fOxfRbsbUU84f_3ijKncKSazPB5WbtBMIOG3XYj8qm5253C4XkCMKtoov.webp?r=b56",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABenbmbDwEwn9fEfLCPdbvM_BGLpwv__zD_Gcx8CmSK9bgfn9e2E0peK7FobSFr1FrO7dyp6OBeBTF50foL4zGl3xBvkCJlq9qOAIp0MCsUM.webp?r=c53",
		description:
			"A 6-year-old with cystic fibrosis recruits the help of an enigmatic new friend to convince her single dad to tell her about her mother.",
		casts: ["Enzo Vogrincic", "Agustin Pardella", "Matias Recalt"],
		genres: ["Spanish", "Dramas", "Movies Based on Books"],
		rating: ["disturbing images", "nudity", "tobacco use"],
	},
	{
		title: "GRAN TURISMO",
		video: "/assets/netflix/videos/GRAN TURISMO.mp4",
		creators: "J.A. Bayona",
		duration: "2h 14m",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABd3VsDTGNYGXZhO1ieCGPgVsP8VxMH0QoCfYaWVbMTbxDxUaNth_BlyHOE65psmCq7sX7jPKkuawkzWfQuQ9WNfLjGTppdv_HFE.webp?r=303",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABT4O7g4tmq6Z5jcfucaLbDgMYtgjLjJ7Np70vf9K2MN2tK_VtrUHLUDh6e7bgJ0MKd0liDPh98W_mnD7Oj7RYh4RcUUL3Vkfy7YEcihc7W8EA-s168qdHFvjxg.webp?r=fe5",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABXptxHDfZkSM_E6rSyPKCApqhHzAE1gxHBbaRua5HqtE7_zQmCQcqydtv5fTxdnZT4lZ-QzoAG-pv9Fg48uWsBT-Sm63OaJ5wiuHIE39pn4.webp?r=434",
		description:
			"Driven teenager Jann Mardenborough uses his video game skills to pursue a once-in-a-lifetime opportunity: becoming a pro racer. Based on a true story.",
		casts: ["Enzo Vogrincic", "Agustin Pardella", "Matias Recalt"],
		genres: ["Spanish", "Dramas", "Movies Based on Books"],
		rating: ["disturbing images", "nudity", "tobacco use"],
	},
	{
		title: "Lookism",
		video: "/assets/netflix/videos/Lookism.mp4",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABWFdCHYjgh_GCSeX1piBaNypa4e6yyGK1p4HZcmP7HgjfEDtgzoUHM3BwpHgUrAKxTpne8A4Xg-ZJ_vHeR2DSRRY4LIocgX-ara0m7RYcU4ZcfyrdWEwM6xT-2tpvUh-w8Tw.jpg?r=c32",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABcTInOnjy040hMcNzcjECIj3OeRKqeoBKkXmDVovWHFnILWJi1RM7OY1YW7KEFdtwkeMgYsCBy9T5-2V0FsehN3vWdbrbOu3WF7D.webp?r=7a3",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABWGlNC8RPiu1ByvabPJa_YPOMS6MSqR7e7nQAG4XHPaVxT73Wg6GjQRCP8MLBm-Rt7rrDkobei1LdTQcGZBrJ4g274GxgQ56oQK57mFwoZw649yT0RW0-vx7KeeiTP53hwkcIGDCXyPdbcZq6cLSYPRoFYvcJDa8Y7-3ByIAITDq7tLDwkUz.webp?r=4de",
		description:
			"In a society that favors good looks, a high school outcast leads a double life switching between his two bodies that are polar opposites in appearance.",
		casts: [
			"Shim Kyu-hyuck",
			"Han Shin",
			"Ryu Seung-gone",
			"Jeong Jae-heon",
			"Nam Doh-hyeong",
			"Hwang Chang-yung",
			"Sa Moon-young",
		],
		genres: [
			"Korean",
			"Teen TV Shows",
			"Anime Series",
			"Drama Anime",
			"School Anime",
		],
		rating: [
			"mature themes",
			"substances",
			"tobacco use",
			"Suitable for persons aged 16 and above and under parental auidance for people under age of 16",
		],
		seasons: [
			{
				episodes: [
					{
						name: "Change",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbaYK2PKmwTnTc3B1kpGCRkaBWLR9fHO6TKeKw3LW9PFU6KWpwjjzlCyDGlDagttuqs5tcVgO68sNcOZkxS-PYe4bD9Vj-yPWkd-GDkd0xwPq10ahoC8qq5p.jpg?r=7c1",
						duration: "24m",
						description:
							"After enduring years of abuse from his peers, Park Hyeong-seok moves to a different neighborhood to start a new life. Big changes are coming for him.",
					},
					{
						name: "New Life",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABQOVNhtc4YCzrmfJvwZJA3Nw1z16Q3E33PEK2Wz1K__n7fPlKI5kW1k8hHEdhqTSxaycVDTnQxM5RyDVusX2l-QgwA3t8HwTWX-7fCO-UczdfpcNkPsGWyiI.jpg?r=081",
						duration: "24m",
						description:
							"Hyeong-seok attends school in his new body by day and works a part-time job as his true self by night – only to learn that nothing has really changed.",
					},
					{
						name: "Friends",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABdKzC6SHRCs7GiIH8p40R4RZ1UhXIfNt7hpwrKDRpOZqJPs5NEtFGHLBUvSQAvFyJMqNLrlXYQaZaZNzwkbtCtJKcnMlU1QfbizHeozHLvuwUT6gyGWnKuNe.jpg?r=98e",
						duration: "25m",
						description:
							"A student by the nickname Basco helps the old Hyeong-seok fight off bullies, while the new Hyeong-seok hangs out with his first-ever group of friends.",
					},
					{
						name: "Mom",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABVmLqZKTDDcaZWtUdTnu75GUKNXIa4tvFbUqovaCBCT79-cL9FNQeiKUX3RsvJBktXGwe3Lt7MSTTmi25SnL9jvv5_GpTr4tUPAyxee85oYAlW1RcpIa5Elb.jpg?r=9db",
						duration: "22m",
						description:
							"Hyeong-seok takes his mother out to a cafe as his transformed self. Basco seethes with righteous indignation when he spots the two together.",
					},
					{
						name: "Kindness",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABf49EowobkQRC_lKRQCL9L-6x2T87cS7D8pZBsY40vw5i3g1eR1x3QkRHvOdLMtsgprvF6o0P-e6KHckXyxZx32dmLH_E_y3uDoyEGXvvsNRtxp8nLPdEqyi.jpg?r=203",
						duration: "21m",
						description:
							"Hyeong-seok lends a hand to other struggling peers in school, while an enigmatic classmate offers him help and gifts when he needs it most.",
					},
					{
						name: "Recommendation",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABSPzMJjf_7O-5iDD9OzHRz-9XDA5v-lcQ7fwknx8mAqfWfkQ3aTFc1oFy53-XiKX8Fh6kf0sfy-qAlgEfh3Ck96NS7OkUn4o4lA3_bm7Fcd_OYAyY8UCu_jn.jpg?r=6aa",
						duration: "26m",
						description:
							"Pyeon Deok-hwa considers performing at the school festival, while others in his class relentlessly try to trample on his dream of becoming a rap artist.",
					},
					{
						name: "Special Training",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABd38aFhZbNd3B12aJEVo6GQFhKll1q_8ZB7Rhh6hvOZQDo65he7M_PFJ16qFTM7_MKCk38kMrrNs0dq5lepHb03bxWQeHY8pQgZSIgrVUXVKhVOITQMXEK9e.jpg?r=bcc",
						duration: "24m",
						description:
							"Under Deok-hwa’s direction, Hyeong-seok unlocks his singing potential as their musical collaboration nurtures their blossoming friendship.",
					},
					{
						name: "Wall",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABaWFwUSKPEGuMdtqtJBfN3rUTbL27YC6cY141RenzJ4mC4SilrNH7d9KHLihAjaxfUxSUH5WBHxoJSuHXcUeiCV7QJLP40vUsfpXxf6GSC_knpatTtSpD42B.jpg?r=9c7",
						duration: "30m",
						description:
							"Competition heats up backstage on the day of the festival. Hyeong-seok and Deok-hwa leave their past and fears behind to deliver a song from the heart.",
					},
				],
			},
		],
	},
	{
		title: "One Piece",
		video: "/assets/netflix/videos/ONE PIECE.mp4",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABZwDvm1n95tdUlapIrF8SzEEuE0Tl8JPM-K-H1Sv-5BciJhzsMgcSj4ddbRCVmRNVDokrNGiwxVSrzS3Jdn_MCWH66u4HvcOqk_iR0vP0lEywOe-79ZAG69JfdyTIn5oINjg.jpg?r=2db",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABbynvSnrIVgQ-j9IOPBO67usElGEU6r4K_g0yBQrqR5xVowHpVttnF5951M9VRrY0J1GmIluxFCzZpLvAJuFKezEq7j73yPIDfx0YipbvZB1kqQ4RCMhGBEFXg.webp?r=db9",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABe3N1i0Zr_ZsXJhc1O2muNJMQtOZ3549BJd3focXUxXvXnbwJbRnrJ6xPNE0J6BWa3CrSYHt-w1JDmLiUzQaiSZUKOr4Fm0DeA5ew8Mh7nFX8-bjWukzmpX-K52rNAbP9KXuqRIYhdVmg7dKna4c9MrKIGBprrdrLDWrbwsNplpLRT2ec5hm.webp?r=b2a",
		description:
			"Stranded on a sinking boat, carefree Luffy begins his journey in search of a pirate king's lost treasure. But first, he'll need a crew, a ship and a map.",
		casts: [
			"Iñaki Godoy",
			"Emily Rudd",
			"Mackenyu",
			"Jacob Romero Gibson",
			"Taz Skylar",
			"Vincent Regan",
			"Jeff Ward",
			"Morgan",
			"Davies",
		],
		genres: [
			"TV Action & Adventure",
			"US TV Shows",
			"Fantasy TV Shows",
			"TV Shows Based on Manga",
		],
		rating: [
			"self-harm,",
			"tobacco use",
			"Suitable for persons aged 16 and above and under parental auidance for people under age of 16",
		],
		seasons: [
			{
				episodes: [
					{
						name: "ROMANCE DAWN",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABa44hIJxPgoU-0PCTL4HUHWiC2HEP19-vvgSWMlmXFI5JOUKPs9J1zUSsCMl7Bz97lxQmReJ2wz2n_rTXm9XVQPfuWGIpRHsidibg86H7I_iBuhaan4d1u8-.jpg?r=db9",
						duration: "65m",
						description:
							"Stranded on a sinking boat, carefree Luffy begins his journey in search of a pirate king's lost treasure. But first, he'll need a crew, a ship and a map.",
					},
					{
						name: "THE MAN IN THE STRAW HAT",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABeDi-cQ0vidweXSTZudpl9xr_TuEF-qHB6SOi_4qU34EvKKygTljm9WW37J7NPzSpJvCpglv_6XhAHJR8Z5MkuhcctSQeLDrFoBjZbvYiAPAsx8qSrakuPzx.jpg?r=389",
						duration: "56m",
						description:
							"After securing a map to the Grand Line, Luffy, Nami and Zoro are taken hostage by a no-nonsense clown. New cadet Koby is cornered by Vice-Admiral Garp.",
					},
					{
						name: "TELL NO TALES",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZF9bL5iI-7x0DrcnPLgQt5XBqnRVbOwh5U5UAjMptOozKREl8UNLyxbZc1u0AGkFbycVHUZ7Zy4_b7hqv2lcAmfqG-gBPXV6SZNg75tpvEFwGa8iDNvMspu.jpg?r=00b",
						duration: "58m",
						description:
							"In need of a proper ship, the gang reaches Syrup Village and meets the cheerful Usopp and his best friend Kaya. A sinister threat disrupts their plans.",
					},
					{
						name: "THE PIRATES ARE COMING",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABXIvM4I1AjSETlmAh-myqzXxKmuhWB9lZ0F9esrptIqOIuKGR_tUBY1dOdoP6-Oi3krNpu0cvKIDyMBY7z21tJm0zSdW-EZ1eJRdlmhxOUyVeE8FE3iHazRq.jpg?r=b18",
						duration: "63m",
						description:
							"With his friends in danger and Klahadore's plan in motion, Usopp seeks help from the Marines. Blades clash when a fierce battle erupts at Kaya's mansion.",
					},
					{
						name: "EAT AT BARATIE!",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABQSBoAtxjpxEXNtOgyHmW5LzY0FeWnWq5xWfAwUSdrv5F0N5kyUN1K7F52_hd5ENzUmeQn91XvGFVMysXXR1DO3VSqmrPIAzvj1V5rwn9s11zJAHs_FsYY1_.jpg?r=6ea",
						duration: "51m",
						description:
							"The Straw Hat Pirates face their first adversary as a group. At a floating fish house, Luffy befriends a cook, and Zoro enters a duel with a warlord.",
					},
					{
						name: "THE CHEF AND THE CHORE BOY",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABVicz9ZW8IPu6_EU7Gml41p_t6l37f7VKcYkJgsU216l0sRZt96_cbnDDGHIXw4eg2sIAMRI1j01Yqj09B1CvbTJ3ca21LdPSUL7ZtcgGqhPxED4bkCaWhFA.jpg?r=d02",
						duration: "55m",
						description:
							"Sanji and head chef Zeff put their differences aside to save a severely wounded Zoro. A ruthless Fishman on a mission stirs up trouble for the crew.",
					},
					{
						name: "THE GIRL WITH THE SAWFISH TATTOO",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABXRODnrZn7cTpex5lk0brXmSHjg8qSWPXQdeOtWHWWWx2FETT6wzlSZaIKMNCZaEDkYtoECJvP_3ZK4SBJuxAj-yZexfeTIj5qhqQdCBa_MJwiI5BYnfKauU.jpg?r=19b",
						duration: "59m",
						description:
							"After striking a deal with a familiar foe to find Arlong, Luffy and his friends set sail for Coco Village and learn about Nami's mysterious past.",
					},
					{
						name: "WORST IN THE EAST",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABQuPqmBJ0theFdt4bqEp9-miQsheEjO1si96nue6uI1wKNKySDXxM3QN6hsA1daTWmfWI6vTu_ViAa7Q1WZwoNwBBi-Hdjhcw9kikC3JgO1hw0TI6_s1Gffb.jpg?r=505",
						duration: "50m",
						description:
							"The Straw Hat crew strives to take down Arlong and the Fishmen once and for all. After a tense family reunion, Luffy inches closer to his dreams.",
					},
				],
			},
		],
	},
	{
		title: "THE PLAYLIST",
		video: "/assets/netflix/videos/The Playlist.mp4",
		mainThambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABWB3D5uBSp7Zu55Z60p3t-15w_ezGNn_OrRYo5Q6djBVQavl1pmch6wyR3UrHPCIiCHT3-15h3D-ixi_b51NuB9KLjjay_pQsReW.webp?r=a61",
		thambnail:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/E8vDc_W8CLv7-yMQu8KMEC7Rrr8/AAAABWB3D5uBSp7Zu55Z60p3t-15w_ezGNn_OrRYo5Q6djBVQavl1pmch6wyR3UrHPCIiCHT3-15h3D-ixi_b51NuB9KLjjay_pQsReW.webp?r=a61",
		titleImage:
			"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/tx1O544a9T7n8Z_G12qaboulQQE/AAAABY4Dl5vT2o4s769PKURNrlhnvUHwIui5yLdHQdwATIAOlzCh_6umkzmTJvSxEC0c-ms0OzhEoWk6Hb8VE6SjH3Ti7B2wVEQQEdABUxl0DkzeBGTJHFwDMVdmmlkhD3ZNpJgeeQSKwAV1y2WIMq3yLGESbZfOdu2yT4XdhTFHmI1OJC2hTJOf.webp?r=cd5",
		description:
			"In this fictionalized account, a Swedish tech entrepreneur and his partners set out to revolutionize the music industry with a legal streaming platform.",
		casts: [
			"Edvin Endre",
			"Christian Hillborg",
			"Ulf Stenberg",
			"Joel Lützow",
			"Janice Kamya Kavander",
			"Gizem Erdogan",
			"Sofia Karemyr",
			"Samuel Fröler",
			"Valter Skarsgärd",
			"Lisette Pagler",
		],
		genres: [
			"Music",
			"TV Dramas",
			"Swedish",
			"TV Shows Based on Books",
			"Scandinavian TV Shows",
		],
		rating: [
			"crude humor",
			"language",
			"mature themes",
			"Suitable for persons aged 16 and above and under parental guidance for people under age of 16",
		],
		seasons: [
			{
				episodes: [
					{
						name: "The Vision",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABVt7-7s84wmrYxtiR6Nbd02UPuD8ZN0WbYjQFR9_l_-3X84TTarrz04PDG4k7MdKkZNYOW9a23mVqhWHOyW91Nu485i4W_qReENS5fSU_cN68u4e69FFuR-_.jpg?r=088",
						duration: "50m",
						description:
							"After achieving an audacious start-up goal, self-taught coder Daniel Ek takes on the challenge of solving the music industry's piracy issue.",
					},
					{
						name: "The Industry",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABcebtqms5E3g_iGf2oS-lTIlqURWgXvFNXEBr-sgr7PLVQq7H7a2qG1q-EgTo5hDc_3c4Ufia2vTRncgFQvd_J6MUY8RLCt0OfGh1lonWcw6CI48xNvtO1ba.jpg?r=934",
						duration: "47m",
						description:
							"During a copyright trial against Pirate Bay, music label head Per Sundin realizes his pushback against piracy might have the opposite effect.",
					},
					{
						name: "The Law",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABaT222ugnVjRK4smf5C4LRxsQMzyPtQlHDwZOzEmsrwrwvb2YVuEoQDz6mtOV490Z3WOzSdFnGVVivM4zyCp5tKRy6yj6YayhfVM_9g0Ee84YvhkY-hknsK1.jpg?r=1ae",
						duration: "56m",
						description:
							"A promising young lawyer leaves her job at a top law firm to tackle Spotify’s complex legal issues and confront the major labels.",
					},
					{
						name: "The Coder",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABdhiabSOyRtFRz4u2efllTRkrinmBvAIFi0VOlsZ9HN_tDrpMANVQzVL0AEQGqbL0SddSz2ioFPNMLpFIdOGs_2SloTO_lYdtSS6S-0LnoVg5EWmSgK6RT-m.jpg?r=1e5",
						duration: "51m",
						description:
							"Sick of his dead-end job, a gifted programmer sharing Daniel's vision of access and independence joins the team to solve their technical challenges.",
					},
					{
						name: "The Partner",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABWIIjCx2lQDbFlb9FID47zonIP9pK_2LmBBMw5vpRobJ9LTrrt9GHsQdHHlSo4p7k3JB1RHnC4cy5xj-b8CIiUgLQ0bZ8Z_fWJfe7zhRbsnq-uQR82AlRyPm.jpg?r=729",
						duration: "45m",
						description:
							"The eccentric entrepreneur and co-founder of Spotify, Martin Lorentzon, looks back on the first five years of 'bankrolling Daniel's mistakes.'",
					},
					{
						name: "The Artist",
						thambnail:
							"https://occ-0-1947-2164.1.nflxso.net/dnm/api/v6/9pS1daC2n6UGc3dUogvWIPMR_OU/AAAABZnxCZ1GmCoiyBSGA_7ZKusNu89TXON6aIMj6PRI5nSWVmrGmR7f7If8S-AA5QaDcL76Ajj1x9ChoyzEqaiDqNIqXff3EXUIYspBF2BNSC70ictupqLA5NIb.jpg?r=d22",
						duration: "48m",
						description:
							"Arguing that Spotify's business model exploits artists, musician Bobbi T faces Daniel Ek in a congressional hearing that could destroy his company.",
					},
				],
			},
		],
	},
];

export default popular;
